<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Media Requests</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="createMediaRequest">Create</button>
            </div>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Media Requests" @keyup.enter="handleSearch">
        <div v-if="results.data && search" class="my-2 text-center">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div v-if="results.data && !search" class="my-2 text-center">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="40%">Subject</div>
                <div class="results-head" data-width="10%">Date/Time</div>
                <div class="results-head" data-width="20%">Requester</div>
                <div class="results-head text-center" data-width="10%">Matched</div>
                <div class="results-head text-center" data-width="10%">Opens</div>
                <div class="results-head text-center" data-width="10%">Replies</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectMediaRequest(result)">
                    <div class="results-cell" data-width="40%">{{ result.req_subject }}</div>
                    <div class="results-cell" data-width="10%">{{ formatDateShort(result.req_datetime) }}</div>
                    <div class="results-cell requester-cell" data-width="20%">
                        <span class="guest requester-type" v-if="result.req_userid == -1">Guest</span>
                        <span class="account requester-type" v-else>Account</span>
                        <span v-if="result.user"> {{ result.user.email }}</span>
                        <span v-else> {{ result.req_email }} </span>
                    </div>
                    <div class="results-cell text-center" data-width="10%">{{ result.req_matches || 0 }}</div>
                    <div class="results-cell text-center" data-width="10%">{{ result.opens_count }}</div>
                    <div class="results-cell text-center" data-width="10%">{{ result.successful_replies_count }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'MediaRequest',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.setMetaTitle('List Media Requests | JournoLink Control')
        this.loadData()
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('mediarequests.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'There was an error retrieving media requests')
                })
        },
        /**
         * Handle the selection of a media request
         *
         * @param  {Object} mediaRequest
         * @return {void}
         */
        handleSelectMediaRequest(mediaRequest) {
            this.$router.push({
                name: 'mediarequests.show', params: {
                    mediaRequestId: mediaRequest.req_id
                }
            })
        },
        createMediaRequest() {
            this.$router.push({name: 'mediarequests.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'mediarequests.list') {
            this.setMetaTitle('List Media Requests | JournoLink Control')
            this.loadData()
        }

        next()
    },
}
</script>

<style lang="less">
.requester-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .requester-type {
        padding: 5px;
        border-radius: 3px;
        color: white;
        margin-right: 0.5rem
    }

    .account {
        background-color: #2980b9;

    }

    .guest {
        background-color: #2c3e50;
    }
}
</style>
